import { Injectable } from '@angular/core';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';

@Injectable({
  providedIn: 'root'
})
export class ManageCalendarFilterService {
  public get baseUrl(): string {
    return `${this.dataCollectorService.baseurl()}`;
  };
  get filterAPIurls(): any{
    return {
      saveFilterUrl: `${this.baseUrl}/misc/quick_filters`,
      userAllUrl: `${this.baseUrl}/user/all`,
      teamsUrl: `${this.baseUrl}/teams/summary`
    }
  };

  constructor(private dataCollectorService: DataCollectorService) { }

  getQuickFilterUrl(uid: string): string {
    return `${this.baseUrl}/misc/quick_filters/${uid}`;
  }
}
